<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import { useStoryblokBridge } from '@storyblok/js';
	import { onMount } from 'svelte';

	let { data } = $props();

	onMount(() => {
		useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory), {});
	});
</script>

<Blok
	content={data.story.content}
	last_updated={data.story.published_at ?? data.story.created_at}
/>
